import { Box } from "@mui/material";
import styled from "@emotion/styled";

export const UserDetailsWrapper = styled(Box)`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const UserDetails = styled(Box)`
  display: flex;
  align-items: center;
`;
